import * as React from "react";
const SvgFiRrTruckLoading = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-truck-loading_svg__a)">
      <path
        fill="#062147"
        d="M20 16V5a3 3 0 0 1 3-3 1 1 0 0 0 0-2 5.006 5.006 0 0 0-5 5v11.279l-2.734.912a3 3 0 0 0-.156-1l-1.553-5.1a3.007 3.007 0 0 0-3.769-1.949l-6.7 2.13A3.013 3.013 0 0 0 1.129 15l1.634 5.373c.107.3.261.58.457.831l-2.536.845a1.001 1.001 0 0 0 .632 1.9L16.1 19.023A4.017 4.017 0 0 0 19.974 24c5.258-.136 5.281-7.831.026-8M4.662 19.748l-1.619-5.327a1.006 1.006 0 0 1 .657-1.243l6.7-2.13a1 1 0 0 1 1.252.638l1.548 5.106.011.031a1 1 0 0 1-.508 1.221l-6.888 2.3a1 1 0 0 1-1.153-.596M19.974 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-9.924-8a1 1 0 0 1-.65 1.256l-2.464.785a1 1 0 1 1-.606-1.907l2.465-.784a1 1 0 0 1 1.255.65"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-truck-loading_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTruckLoading;
